import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getOrders } from "../../api";
import { ReactComponent as EmailIcon } from "../../inlineSvgs/email.svg";
import { ReactComponent as CallIcon } from "../../inlineSvgs/call.svg";
import { ReactComponent as UserIcon } from "../../inlineSvgs/user.svg";
import { ReactComponent as ArrowIcon } from "../../inlineSvgs/arrow-right-2.svg";
import { ReactComponent as LogoIcon } from "../../inlineSvgs/logo-circle.svg";
import { updateUserAsyncThunk } from "../../store/slice/userSlice";
import { deleteUser } from "../../api";
import { showNotification } from "../../config";
import ModalWindow from "../ModalWindow";

const ProfileInfo = () => {
  const [isShowBtn, setShowBtn] = useState(false);
  const { screen, user } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
  } = useForm({
    defaultValues: user,
  });

  useEffect(() => {
    getUserOrders();
  }, []);

  const getUserOrders = async () => {
    const orders = await getOrders();
    setShowBtn(orders.data?.length === 0);
  };

  const onSubmit = async (data) => {
    const formatedData = {
      newData: {
        firstName: data.firstName,
        lastName: data.lastName,
      },
      reset: reset,
    };

    dispatch(updateUserAsyncThunk(formatedData));
  };

  const deleteAccount = async () => {
    try {
      await deleteUser();
      showNotification("Account deleted successfully", "success");
    } catch {
      showNotification("Something went wrong");
    }
  };

  return screen.mobile ? (
    <>
      <div className="profile-info-mobile">
        <div className="info">
          <div className="name">
            <span>{user?.firstName}</span>
            <span>{user?.lastName}</span>
          </div>
          <div className="email">{user?.email}</div>
        </div>
        <div className="edit-btn">
          <ModalWindow
            title={"Receipt"}
            btnContent={
              <span>
                Edit <ArrowIcon />
              </span>
            }
            btnClass="not-button"
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <div>
                <label htmlFor="userName">Name</label>
                <div className={errors.firstName ? "input-wrapper error" : "input-wrapper"}>
                  <div className="icon-wrapper">
                    <UserIcon />
                  </div>
                  <input
                    id="userName"
                    type="text"
                    placeholder="Enter your Name"
                    {...register("firstName", {
                      required: { value: true, message: "This is required field" },
                      pattern: {
                        message: "There should only be letters",
                        value: /^[a-zA-Z-]{1,50}$/,
                      },
                    })}
                  />
                  {errors.firstName && <p className="errors">{errors.firstName.message}</p>}
                </div>
              </div>
              <div>
                <label htmlFor="userSurname">Surname</label>
                <div className={errors.lastName ? "input-wrapper error" : "input-wrapper"}>
                  <div className="icon-wrapper">
                    <UserIcon />
                  </div>
                  <input
                    id="lastName"
                    type="text"
                    placeholder="Enter your Surname"
                    {...register("lastName", {
                      required: { value: true, message: "This is required field" },
                      pattern: {
                        message: "There should only be letters",
                        value: /^[a-zA-Z-]{1,50}$/,
                      },
                    })}
                  />
                  {errors.lastName && <p className="errors">{errors.lastName.message}</p>}
                </div>
              </div>

              {!!Object.keys(dirtyFields).length ? (
                <button type="submit" className="beauty-btn fill">
                  Save Changes
                </button>
              ) : (
                <button type="button" className="not-button delete-acc-btn" onClick={() => deleteAccount()}>
                  Delete account
                </button>
              )}
            </form>
          </ModalWindow>
        </div>
      </div>
      {isShowBtn && (
        <Link to={"/"}>
          <div className="first-order-btn" style={{ backgroundImage: `url(./img/BG.jpg)` }}>
            <div className="logo">
              <LogoIcon />
            </div>
            <div className="text">
              <div className="text__title">Your first order</div>
              <div className="text__sub-title">Excellent results and premium care.</div>
            </div>
            <div className="setting__arrow">
              <ArrowIcon />
            </div>
          </div>
        </Link>
      )}
    </>
  ) : (
    <div className="profile-info">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label htmlFor="userName">Name</label>
          <div className={errors.firstName ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <UserIcon />
            </div>
            <input
              id="userName"
              type="text"
              placeholder="Enter your Name"
              {...register("firstName", {
                required: { value: true, message: "This is required field" },
                pattern: {
                  message: "There should only be letters",
                  value: /^[a-zA-Z-]{1,50}$/,
                },
              })}
            />
            {errors.firstName && <p className="errors">{errors.firstName.message}</p>}
          </div>
        </div>
        <div>
          <label htmlFor="userSurname">Surname</label>
          <div className={errors.lastName ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <UserIcon />
            </div>
            <input
              id="lastName"
              type="text"
              placeholder="Enter your Surname"
              {...register("lastName", {
                required: { value: true, message: "This is required field" },
                pattern: {
                  message: "There should only be letters",
                  value: /^[a-zA-Z-]{1,50}$/,
                },
              })}
            />
            {errors.lastName && <p className="errors">{errors.lastName.message}</p>}
          </div>
        </div>

        <label htmlFor="email">Email Address</label>
        <div className={errors.email ? "input-wrapper error" : "input-wrapper"}>
          <div className="icon-wrapper">
            <EmailIcon />
          </div>
          <input
            readOnly
            id="email"
            type="email"
            placeholder="Enter your email or phone number"
            {...register("email", {
              required: { value: true, message: "This is required field" },
            })}
          />
          {errors.email && <p className="errors">{errors.email.message}</p>}
        </div>

        <div>
          <label htmlFor="phone">Phone Number</label>
          <div className={errors.phone ? "input-wrapper error" : "input-wrapper"}>
            <div className="icon-wrapper">
              <CallIcon />
            </div>
            <input
              readOnly
              id="phone"
              type="phone"
              placeholder=""
              {...register("phone", {
                required: { value: true, message: "This is required field" },
              })}
            />
            {errors.phone && <p className="errors">{errors.phone.message}</p>}
          </div>
        </div>

        {!!Object.keys(dirtyFields).length ? (
          <button type="submit" className="beauty-btn fill">
            Save Changes
          </button>
        ) : (
          <button type="button" className="not-button delete-acc-btn" onClick={() => deleteAccount()}>
            Delete account
          </button>
        )}
      </form>
    </div>
  );
};

export default ProfileInfo;
